import React from "react"
import { C, radius, shadow, transition } from "@/theme/newDesignTokens"

/* ── Shared modal styles ── */

export const overlay: React.CSSProperties = {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.35)",
    zIndex: 1300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

export const brSpacer: React.CSSProperties = {
    display: "block",
    height: "10px",
}

/* ── Confirm modal ── */

export const confirmCard: React.CSSProperties = {
    background: C.white,
    borderRadius: radius.xl,
    boxShadow: shadow.lg,
    padding: 24,
    maxWidth: 440,
    width: "90%",
}

export const confirmTitle: React.CSSProperties = {
    fontSize: 16,
    fontWeight: 700,
    color: C.navyDark,
    marginBottom: 12,
}

export const confirmContent: React.CSSProperties = {
    fontSize: 14,
    color: C.medGray,
    marginBottom: 20,
}

export const confirmButtonRow: React.CSSProperties = {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
}

export const cancelButton: React.CSSProperties = {
    background: C.offWhite,
    color: C.navyDark,
    border: `1px solid ${C.lightGray}`,
    borderRadius: radius.md,
    padding: "8px 16px",
    fontSize: 13,
    cursor: "pointer",
    fontWeight: 500,
}

export const okButton: React.CSSProperties = {
    background: C.navy,
    color: C.white,
    border: "none",
    borderRadius: radius.md,
    padding: "8px 16px",
    fontSize: 13,
    cursor: "pointer",
    fontWeight: 500,
}

/* ── Welcome modal ── */

export const welcomeCard: React.CSSProperties = {
    position: "relative",
    background: C.white,
    borderRadius: radius.xl,
    boxShadow: shadow.lg,
    padding: 32,
    maxWidth: 520,
    width: "90%",
}

export const welcomeCloseButton: React.CSSProperties = {
    position: "absolute",
    top: 16,
    right: 16,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

export const welcomeTitleRow: React.CSSProperties = {
    textAlign: "center",
    marginBottom: 8,
}

export const welcomeTitle: React.CSSProperties = {
    fontSize: 20,
    fontWeight: 700,
    color: C.navyDark,
}

export const welcomeSubtitle: React.CSSProperties = {
    fontSize: 14,
    color: C.medGray,
    textAlign: "center",
    marginBottom: 24,
}

export const modeCardsRow: React.CSSProperties = {
    display: "flex",
    gap: 12,
    marginBottom: 20,
}

export const getModeCard = (isHovered: boolean): React.CSSProperties => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    padding: 20,
    border: `2px solid ${isHovered ? C.navy : C.lightGray}`,
    borderRadius: radius.lg,
    background: C.white,
    cursor: "pointer",
    transition: transition.fast,
    transform: isHovered ? "scale(1.02)" : "scale(1)",
    boxShadow: isHovered ? shadow.md : "none",
})

export const modeCardTitle: React.CSSProperties = {
    fontSize: 16,
    fontWeight: 600,
    color: C.navyDark,
}

export const modeCardDescription: React.CSSProperties = {
    fontSize: 13,
    color: C.medGray,
    textAlign: "center",
}

export const checkboxRow: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
}

export const checkboxLabel: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    fontSize: 13,
    color: C.medGray,
}

export const checkboxInput: React.CSSProperties = {
    accentColor: C.navy,
}
